<template>
  <div>
    <!-- Off-canvas menu for mobile -->
    <div v-show="show" class="md:hidden">
      <transition name="fade" enter-class="opacity-0" enter-to-class="opacity-100" leave-class="opacity-100" leave-to-class="opacity-0">
        <div
          v-show="show"
          @click="$emit('close')"
          class="fixed inset-0 z-30 transition-opacity ease-linear duration-300"
        >
          <div @click.self="$emit('close')" class="absolute inset-0 bg-gray-600 opacity-75" />
        </div>
      </transition>
      <div class="fixed inset-0 flex z-40">
        <transition
          enter-class="-translate-x-full"
          enter-to-class="translate-x-0"
          leave-class="translate-x-0"
          leave-to-class="-translate-x-full"
        >
          <div
            v-show="show"
            class="flex-1 flex flex-col max-w-xs w-full bg-phaneroo-500 transform ease-in-out duration-300"
          >
          <div class="absolute top-0 right-0 -mr-14 p-1">
            <button v-show="show" @click="$emit('close')"
              class="flex items-center justify-center h-12 w-12 rounded-full focus:outline-none focus:bg-gray-600">
              <svg class="h-6 w-6 text-white" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="flex-1 h-0 pt-5 pb-4 overflow-y-auto">
            <router-link to="/" class="flex-shrink-0 flex items-center px-4">
              <Phaneroo class="h-8 w-auto"  />
            </router-link>
            <nav class="mt-5 px-2">
              <router-link @click="$emit('close')" active-class="bg-phaneroo-700" to="/dashboard"
                class="group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="church"/>
                Prayer Requests
              </router-link>
              <router-link @click.native="$emit('close')" v-if="user.isAdmin" active-class="bg-phaneroo-700" to="/dashboard/testimonies"
                class="group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="heart"/>
                Testimonies
              </router-link>
              <router-link @click.native="$emit('close')" v-if="user.isAdmin" active-class="bg-phaneroo-700" to="/dashboard/managecategories"
                class="group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="cubes"/>
                Manage Categories
              </router-link>
              <router-link @click.native="$emit('close')" v-if="user.isAdmin" active-class="bg-phaneroo-700" to="/dashboard/manageusers"
                class="group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-white focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="users"/>
                Manage Users
              </router-link>
              <button disabled
                @click="$emit('close')"
                class="mt-1 cursor-not-allowed group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-phaneroo-50 hover:text-white hover:bg-phaneroo-500 focus:outline-none focus:text-white focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="books"/>
                Resources <span class="badge text-xs bg-phaneroo-100 text-gray-800 rounded-full font-bold uppercase ml-3">Coming</span>
              </button>
            </nav>
          </div>
          <div class="flex-shrink-0 flex flex-col border-t border-phaneroo-500 p-4">
            <b-tooltip type="is-light" size="is-small" animated :active="isShowingTooltip" label="Copied invite link">
              <button
                @click="copyShareLink"
                class="group w-full flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-phaneroo-50 hover:text-white hover:bg-phaneroo-500 focus:outline-none focus:text-white focus:bg-phaneroo-600 transition ease-in-out duration-150">
                <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="share-alt" pack="fal" />
                Invite user
              </button>
            </b-tooltip>
            <br>
            <router-link to="/account/profile" class="flex-shrink-0 group block focus:outline-none">
              <div class="flex items-center">
                <div>
                  <img
                    v-if="user.avatarUrl"
                    class="inline-block h-10 w-10 rounded-full border-gray-100 border-2"
                    :src="user.avatarUrl"
                    :alt="`${user.firstName} ${user.lastName} photo`"
                  />
                  <b-icon
                    v-else
                    icon="user-alt"
                    class="inline-block text-white rounded-full"
                  />
                </div>
                <div class="ml-3">
                  <p class="text-base leading-6 font-medium text-white">
                    {{ user.firstName}} {{ user.lastName }}
                  </p>
                  <p
                    class="text-sm leading-5 font-medium text-phaneroo-50 group-hover:text-indigo-100 group-focus:underline transition ease-in-out duration-150">
                    {{ userType }}
                  </p>
                </div>
              </div>
            </router-link>
          </div>
        </div>
        </transition>
        <div class="flex-shrink-0 w-14" @click.self="$emit('close')">
          <!-- Force sidebar to shrink to fit close icon -->
        </div>
      </div>
    </div>

    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0 h-full">
      <div class="flex flex-col w-64 border-r border-gray-200 bg-phaneroo-500">
        <div class="h-0 flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
          <router-link to="/" class="flex-shrink-0 flex items-center px-4">
            <Phaneroo class="h-10 w-auto" />
          </router-link>
          <!-- Sidebar component, swap this element with another sidebar if you like -->
          <nav class="mt-5 flex-1 px-2 bg-phaneroo-500">
            <router-link to="/dashboard" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md hover:text-phaneroo-50 focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="pray"/>
              Prayer Requests
            </router-link>
            <router-link v-if="user.isAdmin" to="/dashboard/testimonies" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md hover:text-phaneroo-50 focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="heart"/>
              Testimonies
            </router-link>
            <router-link v-if="user.isAdmin" to="/dashboard/managecategories" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md hover:text-phaneroo-50 focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="cubes"/>
              Manage categories
            </router-link>
            <router-link v-if="user.isAdmin" to="/dashboard/manageusers" href="#" class="group flex items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md hover:text-phaneroo-50 focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="users"/>
              Manage users
            </router-link>
            <button disabled href="#" class="group cursor-not-allowed flex items-center px-2 py-2 text-sm leading-5 font-medium text-white rounded-md hover:text-phaneroo-50 focus:outline-none focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="books"/>
              Resources <span class="badge text-xs bg-phaneroo-100 text-gray-800 rounded-full font-bold uppercase ml-3">Coming</span>
            </button>
          </nav>
        </div>
        <div class="flex-shrink-0 flex flex-col border-t border-phaneroo-500 p-4">
          <b-tooltip type="is-light" size="is-small" animated label="Copied invite link!" :active="isShowingTooltip">
            <button
              @click="copyShareLink"
              class="mb-4 w-full group flex items-center px-2 py-2 text-base leading-6 font-medium rounded-md text-phaneroo-50 hover:text-white hover:bg-phaneroo-500 focus:outline-none focus:text-white focus:bg-phaneroo-600 transition ease-in-out duration-150">
              <b-icon class="mr-3 h-6 w-6 text-phaneroo-200 group-focus:text-phaneroo-50 transition ease-in-out duration-150" icon="share-alt" pack="fal" />
              Invite friend
            </button>
          </b-tooltip>
          <router-link to="/account/profile" class="flex-shrink-0 group block focus:outline-none">
            <div class="flex items-center">
              <div>
                <img
                    v-if="user.avatarUrl"
                    class="inline-block h-9 w-9 rounded-full border-gray-100 border-2"
                    :src="user.avatarUrl"
                    :alt="`${user.firstName} ${user.lastName} photo`"
                  />
                  <b-icon
                    v-else
                    icon="user-alt"
                    class="inline-block text-white rounded-full"
                  />
              </div>
              <div class="ml-3">
                <p class="text-sm leading-5 font-medium text-white">
                  {{ user.firstName}} {{ user.lastName }}
                </p>
                <p
                  class="text-xs leading-4 font-medium text-phaneroo-50 group-hover:text-indigo-100 group-focus:underline transition ease-in-out duration-150">
                  {{ userType }}
                </p>
              </div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import copy from 'copy-to-clipboard'
import Phaneroo from '@/components/resources/phaneroo-logo'

export default {
  name: 'SideBar',
  inject: ['$user'],
  components: {
    Phaneroo
  },
  data () {
    return {
      copyTimeout: null,
      isShowingTooltip: false
    }
  },
  computed: {
    user () {
      return this.$user()
    },
    userType () {
      if (this.user.isAdmin) return 'Admin'
      else if (this.user.isPastor) return 'Pastor'
      else if (this.user.isMember) return 'Member'
      else return 'Member'
    }
  },
  props: {
    show: Boolean
  },
  methods: {
    copyShareLink () {
      this.isShowingTooltip = true
      if (this.copyTimeout) clearTimeout(this.copyTimeout)

      copy('https://prayer.phaneroo.org/signup')

      this.copyTimeout = setTimeout(() => {
        this.isShowingTooltip = false
        this.copyTimeout = null
      }, 1000)
    }
  }
}
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  @apply bg-phaneroo-700
}

.badge {
  font-size: 0.7em;
  padding: 0.05rem 0.6rem;
}
</style>
